// Components
import ModalForm from '../ModalForm/ModalForm';

const Modal = ({ open, onClose, children, formData }) => (
  <div className={`Modal-wrapper ${open ? 'Modal-open' : ''}`}>
    <div className="Modal-overlay" onClick={onClose} />
    <div className="Modal-container" onClick={(e) => e.stopPropagation()}>
      {children}
      <div className="Modal-close" onClick={onClose}>
        <svg width="36" height="36">
          <use xlinkHref="#close" />
        </svg>
      </div>
      {formData && <ModalForm {...formData} />}
    </div>
  </div>
);
export default Modal;
